import * as yup from 'yup';

export enum ForgotPasswordFormFieldNames {
  phoneCode = 'phoneCode',
  phoneNumber = 'phoneNumber'
}

export interface ForgotPasswordFormDto {
  [ForgotPasswordFormFieldNames.phoneCode]: string;
  [ForgotPasswordFormFieldNames.phoneNumber]: string;
}

export const forgotPasswordFormSchema = yup.object({
  [ForgotPasswordFormFieldNames.phoneCode]: yup.string().required('Phone code is required'),
  [ForgotPasswordFormFieldNames.phoneNumber]: yup.string().required('Phone number is required')
});

export const getDefaultValues = (): ForgotPasswordFormDto => ({
  [ForgotPasswordFormFieldNames.phoneCode]: '',
  [ForgotPasswordFormFieldNames.phoneNumber]: ''
});
